import styled from 'styled-components'

const Item = styled.div.attrs({
  style: ({ opacity = 1, translateY = 0 }) => ({
    opacity,
    transform: `translateY(${translateY}%)`,
  }),
})`
  animation: ${(props) =>
    props.hoverAnimation
      ? `${props.theme.animation.upAndDown} 2s infinite`
      : 'none'};
  animation-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);
  position: absolute;
  pointer-events: none;

  left: ${(props) => props.left || 0}%;
  bottom: ${(props) => props.bottom || 0}%;
  width: ${(props) => props.width || 0}%;
`
export const AnchorItem = Item.withComponent('a')

export default Item



// WEBPACK FOOTER //
// ./src/components/Item.js